<template>
  <h1>
    <slot></slot>
  </h1>
</template>

<script>
export default {
  name: "subTitle",
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 1.1rem;
  margin: 0px 0 15px 0;
  border-radius: 0px;
  padding: 10px 0px;
  font-weight: bold;
  border-bottom: 1px solid rgb(231, 231, 231);
  i {
    margin-right: 3px;
  }
}
</style>
